import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {VendorDisc} from '~/ViewInvitation/common/VendorDisc';
import {selectGiftingData} from '~/ViewInvitation/selectors/gifting';
import {Divider} from '~library/atoms/Divider';
import {Typography} from '~library/atoms/Typography';
import {ParentPost} from './ParentPost';

export const AllGuestPosts = (props) => {
  const {
    label,
    guests,
    openCommentEditor,
    onCommentEditorOpen,
    onCommentEditorClose,
    removeAds, // a.k.a. "freemium or premium"
  } = props;

  const giftingData = useSelector(selectGiftingData, shallowEqual);

  const AllGuestPostsAffiliateAd = ({giftingData}) => {
    return (
      <div className="whos-coming-ad">
        <Typography variant="header5" className="whos-coming-ad__title">
          Shop deals on last-minute gifts
        </Typography>
        <VendorDisc
          registry={giftingData}
          displayText="Buy Your Gift Now"
          dataQaId="af-glist-disc-amazon"
        />
      </div>
    );
  };

  return guests.map((guest, i) => {
    const showAd = i === 0 && label === 'yes' && !removeAds;
    const parentPostId = guest.post_id || null;
    return (
      <React.Fragment key={`guest__${parentPostId || guest.guest_id}`}>
        <ParentPost
          guest={guest}
          label={label}
          parentPostId={parentPostId}
          isCommentOpen={openCommentEditor === parentPostId}
          onCommentEditorOpen={onCommentEditorOpen}
          onCommentEditorClose={onCommentEditorClose}
        />
        {showAd && (
          <>
            <AllGuestPostsAffiliateAd giftingData={giftingData} />
            <Divider />
          </>
        )}
      </React.Fragment>
    );
  });
};
